import React, { useState, useEffect, useRef } from 'react';
import './styless.css';
import { useTranslation } from 'react-i18next';
import IconUp from "../../../assets/images/chevron-up.png";
import IconDown from "../../../assets/images/chevron-down.png";

const MultiSelect = ({ options, selected, setSelected, disabled }) => {
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const dropdownRef = useRef(null);
  const { t } = useTranslation();

  // 🟢 Initialiser selectedOptions depuis selected au début
  useEffect(() => {
    const initialSelectedValues = selected.map(item => item.value);
    setSelectedOptions(initialSelectedValues);
  }, [selected]);

  const toggleDropdown = (event) => {
    event.stopPropagation();
    setIsOpen(!isOpen);
  };

  // 🟢 Gérer ajout / suppression
  const handleOptionChange = (option) => {
    setSelectedOptions((prevSelectedOptions) => {
      if (prevSelectedOptions.includes(option.value)) {
        return prevSelectedOptions.filter((item) => item !== option.value);
      } else {
        return [...prevSelectedOptions, option.value];
      }
    });
  
    setSelected((prevSelected) => {
      const isAlreadySelected = prevSelected.some((item) => item.value === option.value);
      if (isAlreadySelected) {
        return prevSelected.filter((item) => item.value !== option.value);
      } else {
        return [...prevSelected, option];
      }
    });
  };

  const renderSelectedText = () => {
    const selectedCount = selectedOptions.length;
    if (selectedCount === 0) return t('noneSelected');
    if (selectedCount <= 2) return selectedOptions.join(', ');
    if (selectedCount === options.length) return t('allSelected');
    return `${selectedCount} ${t('selected')}`;
  };

  const filteredOptions = options.filter(option =>
    option.value.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="multi-select" ref={dropdownRef} title={selectedOptions.join(', ')}>
      <div className="dropdown">
        <button
          type="button"
          className="dropdown-button"
          onClick={toggleDropdown}
          style={{
            paddingLeft: '5%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: "150%",
          }}
        >
          <span className="dropdown-text" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1 }}>
            {renderSelectedText()}
          </span>
          <img 
            src={isOpen ? IconUp : IconDown} 
            alt={isOpen ? "Collapse" : "Expand"} 
            style={{ width: '8%', height: '70%', marginRight: '4%' }}
          />
        </button>

        {isOpen && (
          <div className="dropdown-menu" style={localStorage.getItem('theme') === 'dark' ? { background: '#292929', color: 'white' } : {}}>
            <div className="search-container">
              <input
                type="text"
                placeholder={t('search')}
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="search-input"
                style={localStorage.getItem('theme') === 'dark' ? { color: 'white' } : {}}
              />
            </div>
            {filteredOptions.map(option => (
              <div key={option.id} className="dropdown-item" style={localStorage.getItem('theme') === 'dark' ? { color: 'white' } : {}}>
                <label>
                  <input
                    type="checkbox"
                    checked={selectedOptions.includes(option.value)}
                    onClick={() => handleOptionChange(option)}
                    disabled={disabled}
                  />
                  {option.value}
                </label>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MultiSelect;
